function getArchiveState(state) {
  return {
    isLoading: state.archive.loading,
    recievedSuccessfulResponse: state.archive.recievedSuccessfulResponse,
    recievedErrorResponse: state.archive.recievedErrorResponse,
    bulkSuccessful: state.archive.bulkSuccessful,
    bulkError: state.archive.bulkError,
    particularNotFree: state.archive.particularNotFree,
    isDraft: state.archive.isDraft,
    isOffline: state.archive.isOffline
  };
}

export { getArchiveState };
